import { Box, BoxProps } from "@mantine/core";

export function DevBadge(props: BoxProps) {
  return (
    <Box
      bg="yellow.1"
      c="gray.6"
      p="xs"
      lh="1"
      style={{ borderRadius: "0.5rem" }}
      fz="sm"
      {...props}
    >
      Development
    </Box>
  );
}
